import React from 'react';
import Button from '../../../../generic-components/Button';

import LeftArrow from '../../svg/left_arrow.svg';
import LeftArrowActive from '../../svg/left_arrow_active.svg';
import RightArrow from '../../svg/right_arrow.svg';
import RightArrowActive from '../../svg/right_arrow_active.svg';

export interface NavigationProps {
  isNext: boolean;
  isPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
}

export const Navigation = ({
  isNext, isPrevious, onNext, onPrevious,
} : NavigationProps) => (
  <div className='h-full' data-testid='InsightsWidgetFooter__navigation'>
    <Button
      className='mr-2'
      id=''
      disable={!isPrevious}
      onClick={onPrevious}
      childElement={<img src={isPrevious ? LeftArrowActive : LeftArrow} alt='arrow-down' className='cursor-pointer' />}
      testId='InsightsWidgetFooter__navigation__back'
    />
    <Button
      className=''
      id=''
      disable={!isNext}
      onClick={onNext}
      childElement={<img src={isNext ? RightArrowActive : RightArrow} alt='arrow-down' className='cursor-pointer' />}
      testId='InsightsWidgetFooter__navigation__next'
    />
  </div>
);
